import './index.css';

export default function Banner() {
  return (
    <div className='Banner'>
      <div className='main_img inner-div'>

      </div>
      <div className='main_desc inner-div'>
        <h1>ROHIT NEGI</h1>
        <h2 className='banner_text'><span className='blue'>Masters in Computer Application </span>graduate with a strong foundation in programming languages and <span className='red'> web development </span> 
         technologies. Proficient in <span className='blue'>HTML, CSS, JavaScript ,React Js, Python, C++,Mongo Db, SQL,. Adept at using Figma</span> for
        design. Eager to contribute to web and <span className='red'> software development</span>  projects and gain practical experience.
</h2>
    
      </div>
    </div>
  )
}
